import React from 'react';

const DrawingTools = ({ selectedTool, setSelectedTool }) => (
    <div style={{
        position: 'absolute',
        top: '16px',
        left: '16px',
        display: 'flex',
        flexWrap: 'wrap',
        width: '300px',
        gap: '8px',
        background: 'white',
        padding: '12px',
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)'
    }}>
        <ToolButton
            tool="pointer"
            selectedTool={selectedTool}
            onClick={setSelectedTool}
            label="Pointer"
            style={{ flex: '1 0 calc(25% - 6px)' }}
        />
        <ToolButton
            tool="freedraw"
            selectedTool={selectedTool}
            onClick={setSelectedTool}
            label="Draw"
            style={{ flex: '1 0 calc(25% - 6px)' }}
        />
        <ToolButton
            tool="textbox"
            selectedTool={selectedTool}
            onClick={setSelectedTool}
            label="Text"
            style={{ flex: '1 0 calc(25% - 6px)' }}
        />
        <ToolButton
            tool="line"
            selectedTool={selectedTool}
            onClick={setSelectedTool}
            label="Line"
            style={{ flex: '1 0 calc(25% - 6px)' }}
        />
        <ToolButton
            tool="rectangle"
            selectedTool={selectedTool}
            onClick={setSelectedTool}
            label="Rectangle"
            style={{ flex: '1 0 calc(25% - 6px)' }}
        />
        <ToolButton
            tool="oval"
            selectedTool={selectedTool}
            onClick={setSelectedTool}
            label="Oval"
            style={{ flex: '1 0 calc(25% - 6px)' }}
        />
        <ToolButton
            tool="marker"
            selectedTool={selectedTool}
            onClick={setSelectedTool}
            label="Marker"
            style={{ flex: '1 0 calc(25% - 6px)' }}
        />
    </div>
);

const ToolButton = ({ tool, selectedTool, onClick, label, style }) => (
    <button
        onClick={() => onClick(tool)}
        style={{
            background: selectedTool === tool ? '#4a86e8' : 'white',
            color: selectedTool === tool ? 'white' : '#666',
            border: '1px solid #e0e0e0',
            padding: '8px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '13px',
            fontWeight: '500',
            transition: 'all 0.2s ease',
            height: '36px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ':hover': {
                background: selectedTool === tool ? '#3b78e7' : '#f5f5f5',
                borderColor: selectedTool === tool ? '#3b78e7' : '#d0d0d0'
            },
            ...style
        }}
    >
        {label}
    </button>
);

export default DrawingTools; 